



















import Vue from 'vue';
import { CTA } from '@/@types/member';
export default Vue.extend({
  name: 'SettingWrapper',
  props: {
    ctaButton: {
      type: Object as () => CTA,
      default() {
        return {};
      },
    },
  },
});
